module.exports = __webpack_public_path__ + "sl.0ab96fdf.svg";